import { AimDevicesEmptyState } from 'pages/Inventory/Applications/AimDevicesEmptyState/AimDevicesEmptyState';
import type { ReactNode } from 'react';

/**
 * Maps an OAS table endpoint id to a custom empty-state node.
 */
export const apiTableNoDataBoxMap: { [key: string]: ReactNode } = {
  '/inventory/applications/devices': <AimDevicesEmptyState />,
};
